module.exports = __webpack_public_path__ + "images/pro/ic-app-api@2x-cdf78ece69ad6364d6a414266ae2789a.png";